import { getLabel } from '../../Language/labels';

export const CategoryButton = ({category, onSelect, inst}) => {
  // const {name, description, image} = category;
  const {name, description} = category;
  return (
    <div className="category-card" onClick={() => onSelect(category)}>
      {/* <img src={image.cdn} alt={name}></img> */}
      <div className="category-card-body">
        <h1>{name}</h1>
        <div className='category-description'>
          <p>{description}</p>
        </div>
        <div className='select-category-wrapper'>
          <span className='select-category-button'>{getLabel('categorySelectButton')}</span>
        </div>
      </div>
    </div>
  )
}